import initialData from '../../initial-data';
import { DEFAULT_RB_AI_DATA } from '../../constants/constants';
import { 
    EDIT_INPUTBOX, 
    HEADING, 
    BACK_BUTTON, 
    SAVE_RESUME, 
    SET_LOGIN_HASH, 
    SET_INITIAL_DATA, 
    ONNEXT_CLICK, 
    ONBACK_CLICK, 
    PREVIEW_RESUME, 
    WITHOUT_MERGE, 
    ONSKIP_CLICK, 
    STORE_VERSION,
    UPDATE_REDUCER,
    UPDATE_RB_SECTION_COMPLETENESS,
    SET_DOWNLOAD_FORMAT,
    SET_USER_DATA,
    SET_MEMBERSHIP_DATA,
    SET_CONTEXT_MENU,
    COVERLETTER_UPDATE,
    INITIALIZE_COVER_LETTER,
    SAVE_AI_CHAT
} from '../actions/actions';
import WpAPI from '../../WpApi';
const _ = require("lodash");
const initialState = WpAPI.initalEntityData();

const editorReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LOGIN_HASH:
            return {
                ...state,
                loginHash: action.loginHash,
                user: action.user? action.user: state.user
            }
            break;
        case SET_INITIAL_DATA:
            const m = _.merge({},
                state,
                action.loginHash ? { loginHash: action.loginHash } : {},
                action.currentResume ? { currentResume: action.currentResume } : {},
                action.user ? { user: action.user } : {}
            )
            //Dont merge resume recursively, if there is already resume. It will stop initializing default or other resume merge
            if(action.resume) return {...m, resume: action.resume}
            else if(action.currentResume && state.currentResume && action.currentResume != state.currentResume ){
                //Change in resume, resume constent should be flush with initial data if resume data is not provided
                return {...m, resume: {...initialData.resume}}
            } else return m
            break;
        case INITIALIZE_COVER_LETTER:
                const mm = _.merge({},
                    state,
                    action.loginHash ? { loginHash: action.loginHash } : {},
                    action.currentLetter ? { currentLetter: action.currentLetter } : {},
                    action.user ? { user: action.user } : {}
                )
                //Dont merge resume recursively, if there is already resume. It will stop initializing default or other resume merge
                if(action.coverletter) return {...mm, coverletter: action.coverletter}
                else if(action.currentLetter && state.currentLetter && action.currentLetter != state.currentLetter ){
                    //Change in resume, resume constent should be flush with initial data if resume data is not provided
                    return {...mm, coverletter: {...initialData.coverletter}}
                } else return mm
                break;
        case ONNEXT_CLICK:
            return {
                ...state,
                ...action.payload
            }
            break;
        case ONBACK_CLICK:
            return {
                ...state,
                back_clicked: action.back_clicked,
                next_label: action.next_label
            }
            break;
        case ONSKIP_CLICK:
            return {
                ...state,
                skip_clicked: action.skip_clicked,
                next_clicked: action.next_clicked,
                next_label: action.next_label
            }
            break;
        case BACK_BUTTON:
            return {
                ...state,
                current_tab: action.payload
            }
            break;
        case SAVE_AI_CHAT:
            return {
                ...state,
                ai_chat: action.data
            }
            break;
        case WITHOUT_MERGE:
            return {
                ...state, resume: {
                    ...action.payload
                }
            }
            break;
        case PREVIEW_RESUME:
            return {
                ...state, resume: {
                    ...state.resume,
                    ...action.payload
                }
            }
            break;
        case STORE_VERSION: {
            return {
                ...state,
                resume: action.resume
            }
            break;
        }
        case UPDATE_REDUCER: {
            return {
                ...state, 
                ...action.payload
            };
            break;
        }
        case SET_DOWNLOAD_FORMAT: {
            return {
                ...state, 
                downloadFormat: action.downloadFormat
            };
            break;
        }
        case SET_USER_DATA: {
            return {
                ...state, 
                user: action.payload
            };
            break;
        }
        case SET_MEMBERSHIP_DATA: {
            return {
                ...state, 
                ...action.payload
            };
            break;
        }
        case SET_CONTEXT_MENU: {
            return {
                ...state, 
                ...action.payload
            };
            break;
        }
        case COVERLETTER_UPDATE: {
            return {
                ...state, 
                coverletter: {
                    ...state.coverletter,
                    ...action.payload
                }
            }
        } break;
        default:
            return state;
            break;
    }
}

export default editorReducer;